"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAndConditionsValidator = void 0;
var _auth = require("@ori/auth");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _logger = require("@ori/logger");
var _react = require("react");
var _setTermsAndConditionsCookie = require("../../utils/setTermsAndConditionsCookie");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const termsType = _globalApiClientReact.GetCustomerRequiredTermsTermsType.TermsAndConditions;
const TermsAndConditionsDialogLazy = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "TermsAndConditionsDialogLazy" */'../TermsAndConditionsDialog/TermsAndConditionsDialogLazy')))).TermsAndConditionsDialogLazy
}));
const TermsAndConditionsValidator = () => {
  const localLogger = (0, _logger.useLogger)('TermsAndConditionsValidator');
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    data: requiredTerms,
    error: fetchingError
  } = (0, _globalApiClientReact.useGetCustomerRequiredTerms)(customerId, {
    termsType
  });
  if (fetchingError) {
    localLogger.error(new Error(`Failed to fetching required TermsAndConditions for customerId: '${customerId}' and termsType: '${termsType}'`, {
      cause: fetchingError
    }));
    return null;
  }
  if (!requiredTerms?.collection[0]) {
    return null;
  }
  const {
    isAccepted,
    termId
  } = requiredTerms.collection[0];
  if (!isAccepted && termId) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(TermsAndConditionsDialogLazy, {
      termId: termId
    });
  }

  // one T&C validation during the session is enough
  (0, _setTermsAndConditionsCookie.setTermsAndConditionsCookie)(customerId);
  return null;
};
exports.TermsAndConditionsValidator = TermsAndConditionsValidator;
